<template>
  <!--
    Botão flutuante de tutoriais.
    Aparece automaticamente nas telas que têm vídeo mapeado em tutoriais.config.js.
    Fica oculto nas telas sem vídeo e nunca aparece na impressão (d-print-none).
  -->
  <v-tooltip left>
    <template v-slot:activator="{ on, attrs }">
      <!-- z-index 5: acima do conteúdo da página, mas abaixo dos dialogs Vuetify (z-index > 200) -->
      <v-btn
        v-show="temTutorial"
        fab
        fixed
        bottom
        right
        color="blue darken-3"
        class="d-print-none"
        style="bottom: 32px; right: 32px; z-index: 5;"
        v-bind="attrs"
        v-on="on"
        @click="abrirTutorial"
      >
        <v-icon large color="white">mdi-help-circle-outline</v-icon>
      </v-btn>
    </template>
    <span>Dúvidas? Clique para assistir ao tutorial deste módulo</span>
  </v-tooltip>
</template>

<script>
import { findTutoriais } from '@/config/tutoriais.config'

export default {
  name: 'TutorialFab',
  computed: {
    // Reativo à navegação: recalcula sempre que $route.path muda
    // Reativo à navegação: recalcula sempre que $route.path muda
    temTutorial() {
      return !!findTutoriais(this.$route.path)
    },
  },
  methods: {
    // Na tela inicial (/app), abre o diagrama interativo do fluxo de trabalho
    // em vez da lista simples de vídeos
    abrirTutorial() {
      if (this.$route.path === '/app') {
        this.$tutorial.abrirFluxo()
        return
      }
      this.$tutorial.abrir(this.$route.path)
    },
  },
}
</script>
